import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "component" }
const _hoisted_3 = { class: "component" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OptionHeader = _resolveComponent("OptionHeader")!
  const _component_Game = _resolveComponent("Game")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OptionHeader, {
        onReleaseSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVoice($event)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Game, { selectedVoice: _ctx.selectedVoice }, null, 8, ["selectedVoice"])
    ])
  ]))
}